function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFF",
  d: "M406.5 50C71.044 55.998 50 36.482 50 300.005 50 562.474 70.121 542.958 406.5 550 747.506 540.177 763 562.474 763 300.005 763 31.843 730.774 54.14 406.5 50zm-70.631 357.589V191.986L519.23 299.918 335.869 407.589z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 813 600",
    width: "1em",
    height: "1em"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE2LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9InlvdXR1YmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHdpZHRoPSI4MTNweCIgaGVpZ2h0PSI2MDBweCIgdmlld0JveD0iMCAwIDgxMyA2MDAiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDgxMyA2MDAiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8cmVjdCBkaXNwbGF5PSJub25lIiBmaWxsPSIjMDAxMjQ3IiB3aWR0aD0iODEzIiBoZWlnaHQ9IjYwMCIvPgo8cGF0aCBmaWxsPSIjRkZGRkZGIiBkPSJNNDA2LjUsNTBDNzEuMDQ0LDU1Ljk5OCw1MCwzNi40ODIsNTAsMzAwLjAwNUM1MCw1NjIuNDc0LDcwLjEyMSw1NDIuOTU4LDQwNi41LDU1MAoJQzc0Ny41MDYsNTQwLjE3Nyw3NjMsNTYyLjQ3NCw3NjMsMzAwLjAwNUM3NjMsMzEuODQzLDczMC43NzQsNTQuMTQsNDA2LjUsNTB6IE0zMzUuODY5LDQwNy41ODlWMTkxLjk4Nkw1MTkuMjMsMjk5LjkxOAoJTDMzNS44NjksNDA3LjU4OXoiLz4KPC9zdmc+Cg==";
export { SvgComponent as ReactComponent };


// WEBPACK FOOTER //
// ./src/assets/svgs/icons/youtube.svg